import React from "react";
import { Box, Button, List, ListItem, ListItemText, styled } from "@mui/material";

import { ParentType } from "../../types";
import FilterListItem from "../FilterListItem";
import CheckboxFilterItem from "./CheckboxFilterItem";
import colors from "../../theme/colors";

export interface CheckboxFilterProps {
  title?: string;
  name?: string;
  tooltip?: string;
  options?: ParentType[];
  value?: ParentType[];
  icon?: any;
  loading?: boolean;
  disabled?: boolean;
  open?: boolean;
  setOpen: (open: boolean) => void;
  onChange: (value: ParentType[]) => void;
  testId?: string;
}

const StyledList = styled(List)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 4,
  overflow: "hidden",
  padding: 0,
}));

const CheckboxFilter: React.FC<CheckboxFilterProps> = ({
  title = "Checkbox Filter",
  name = "checkbox-filter",
  tooltip,
  options = [],
  value = [],
  icon,
  loading,
  disabled,
  open,
  setOpen,
  onChange,
  testId,
}) => {
  return (
    <FilterListItem title={title} tooltip={tooltip} selected={value.length} icon={icon} open={open} setOpen={setOpen}>
      <StyledList id={name} data-testid={testId}>
        {loading ? (
          <ListItem dense>
            <ListItemText primary="Loading..." />
          </ListItem>
        ) : (
          options
            .filter(option => [undefined, 0, null].includes(option.parent_id))
            .map((option, index, array) => (
              <CheckboxFilterItem
                key={String(option.id)}
                option={option}
                options={options.filter(item => item.parent_id === option.id)}
                value={value}
                disabled={disabled}
                onChange={onChange}
                last={index === array.length - 1}
              />
            ))
        )}
      </StyledList>
      {options.length > 2 && (
        <Box marginTop={4}>
          <Button
            variant="outlined"
            size="small"
            disabled={disabled || loading || value.length === options.length}
            onClick={() => {
              onChange(options);
            }}
            style={{ backgroundColor: colors.white }}
          >
            Select all
          </Button>
        </Box>
      )}
    </FilterListItem>
  );
};

export default CheckboxFilter;
